import React, { useEffect } from 'react';
import styles from './styles.module.scss';

export type ToastType = 'success' | 'error' | 'info' | 'warning';

interface ToastProps {
  message: string;
  type?: ToastType;
  duration?: number;
  onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({
    message,
    type = 'info',
    duration = 3000,
    onClose,
}) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, duration);

        return () => clearTimeout(timer);
    }, [duration, onClose]);

    return (
        <div className={`${styles.toast} ${styles[type]}`}>
            <div className={styles.content}>
                {type === 'success' && <span className={styles.icon}>✓</span>}
                {type === 'error' && <span className={styles.icon}>✕</span>}
                {type === 'warning' && <span className={styles.icon}>!</span>}
                {type === 'info' && <span className={styles.icon}>i</span>}
                <span className={styles.message}>{message}</span>
            </div>
            <button className={styles.closeButton} onClick={onClose}>×</button>
        </div>
    );
};

export default Toast; 